jQuery(function($) {
    /* Fetch hash from URL and scroll to target while collapsing it */
	$(window).on('load', function(e){
		if(!$('.faq-module').length) return;
		if(window.location.hash) {
			var $target = $(window.location.hash);
			$($target.parent().data('target')).collapse('show');
		}
	});
	/* On click fetch href, scroll to said href and change hash in URL to target href */
    $('.faq-module').on('click', '[data-target]', function() {
        var $target = $($(this).attr('href'));
        var scrollTarget = $target.offset().top - $(this).height(); // -30 to compensate for div height.
        var $collapsible = $target.closest('.faq-module').find('.collapse.show');
        // Check if an accordion is collapsed.
        if($collapsible.length > 0) {
            // If its collapsed, check if its height is bigger than the targets height.
            if($(this).offset().top > $collapsible.offset().top) {
                scrollTarget = $target.offset().top - $target.closest('.faq-module').find('.collapse.show').height() - $(this).height();
            }
        }
        $('html, body').animate({
            scrollTop: scrollTarget
        }, 500);
        window.location.hash = $(this).attr('href');
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/faq.js
// module id = 17
// module chunks = 0